import { lazy, FC } from 'react';
import { useFragment, graphql } from 'react-relay';

import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense';
import { PdpSharedAuctionsWatchLoading } from './PdpSharedAuctionsWatchLoading';

import type { PdpSharedAuctionsWatchLazy_item$key } from './__generated__/PdpSharedAuctionsWatchLazy_item.graphql';
import type { PdpSharedAuctionsWatchLazy_user$key } from './__generated__/PdpSharedAuctionsWatchLazy_user.graphql';

const PdpSharedAuctionsWatch = lazy(
    () => import(/* webpackChunkName: "PdpSharedAuctionsWatch" */ './PdpSharedAuctionsWatch')
);

type Props = {
    item: PdpSharedAuctionsWatchLazy_item$key;
    user: PdpSharedAuctionsWatchLazy_user$key;
    buttonSize: 'small' | 'medium' | 'large';
    showHeartCount: boolean;
};

const itemFragment = graphql`
    fragment PdpSharedAuctionsWatchLazy_item on Item {
        ...PdpSharedAuctionsWatch_item
        isAuctionWatchCtaVisible
    }
`;

const userFragment = graphql`
    fragment PdpSharedAuctionsWatchLazy_user on User {
        ...PdpSharedAuctionsWatch_user
    }
`;

export const PdpSharedAuctionsWatchLazy: FC<Props> = ({
    item: itemRef,
    user: userRef,
    buttonSize,
    showHeartCount,
}) => {
    const item = useFragment(itemFragment, itemRef);
    const user = useFragment(userFragment, userRef);
    const isAuctionWatchCtaVisible = item?.isAuctionWatchCtaVisible;

    if (!isAuctionWatchCtaVisible) {
        return null;
    }

    return (
        <ClientSuspense fallback={<PdpSharedAuctionsWatchLoading buttonSize={buttonSize} />}>
            <PdpSharedAuctionsWatch
                showHeartCount={showHeartCount}
                item={item}
                buttonSize={buttonSize}
                user={user}
            />
        </ClientSuspense>
    );
};
